import * as React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

import './layout.css';

const propTypes = {
  children: PropTypes.node.isRequired,
};

function Layout({ children }) {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
      <div className="container">
      {children}
      </div>
  );
}

Layout.propTypes = propTypes;
export default Layout;
